import { z } from 'zod';
/** Roles applicatifs. ADMIN > OPERATEUR > LECTURE (ordre de privilege decroissant). */
export const USER_ROLES = ['ADMIN', 'OPERATEUR', 'LECTURE'];
export const userRoleSchema = z.enum(USER_ROLES);
/** Libelles francais affiches dans l'interface. */
export const USER_ROLE_LABELS = {
    ADMIN: 'Administrateur',
    OPERATEUR: 'Opérateur',
    LECTURE: 'Lecture seule',
};
/**
 * Niveau de privilege : plus la valeur est haute, plus le role est privilegie.
 * Utilise par le garde de roles cote API et par le front pour masquer des entrees.
 */
export const USER_ROLE_LEVEL = {
    LECTURE: 1,
    OPERATEUR: 2,
    ADMIN: 3,
};
export function hasAtLeastRole(role, required) {
    return USER_ROLE_LEVEL[role] >= USER_ROLE_LEVEL[required];
}
export function isUserRole(value) {
    return typeof value === 'string' && USER_ROLES.includes(value);
}
//# sourceMappingURL=roles.js.map